import { PortCall } from './PortCall';

export class Rotation {
    constructor(
        portCallArray: PortCall[],
        lastUpdatedUtc: Date | null,
        stowagePlanName: string,
        lastImosSynchronizedUtc: Date,
        lastImosUpdatedUtc: Date
    ) {
        this.portCallArray = portCallArray;
        this.lastUpdatedUtc = lastUpdatedUtc;
        this.stowagePlanName = stowagePlanName;
        this.lastImosSynchronizedUtc = lastImosSynchronizedUtc;
        this.lastImosUpdatedUtc = lastImosUpdatedUtc;
        this.filteredPortCallIds = new Set();
    }
    portCallArray: PortCall[];
    lastUpdatedUtc: Date | null;
    stowagePlanName: string;
    lastImosSynchronizedUtc: Date;
    lastImosUpdatedUtc: Date;
    /** Port call IDs that were filtered out by stowage integration logic */
    filteredPortCallIds: Set<number>;
}
